// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_overflow__N31ec {
    overflow-x: hidden;
    margin: 5px 0;
}

.style_start__hiOB2 {
    position: absolute;
    top: 5px;
    left: 5px;
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ActiveChatInfo/MessageTypes/style.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb","sourcesContent":[".overflow {\n    overflow-x: hidden;\n    margin: 5px 0;\n}\n\n.start {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overflow": `style_overflow__N31ec`,
	"start": `style_start__hiOB2`
};
export default ___CSS_LOADER_EXPORT___;
